

export { SimpleForm } from './src/index';
